import React from 'react';

/* Faint topographic contour lines across the whole section. One hand-drawn
   ring is repeated outward from a single summit (upper right) at growing
   scales and slight rotations, so the lines never cross and read as terrain
   rather than a pattern. Hairline, in the border color. Decorative only. */
const RING = 'M200 72 C252 66 296 92 306 134 C316 176 286 214 236 224 C182 235 120 216 102 172 C86 132 128 78 200 72Z';

/* The ring is centered near (205, 150) in its own coordinates. */
const SUMMIT = {
  x: 930,
  y: 190
};
const RINGS = [{
  s: 0.25,
  r: 0
}, {
  s: 0.5,
  r: 6
}, {
  s: 0.8,
  r: -4
}, {
  s: 1.15,
  r: 7
}, {
  s: 1.55,
  r: -5
}, {
  s: 2.0,
  r: 4
}, {
  s: 2.5,
  r: -3
}, {
  s: 3.05,
  r: 6
}, {
  s: 3.65,
  r: -4
}, {
  s: 4.3,
  r: 3
}, {
  s: 5.0,
  r: -2
}, {
  s: 5.8,
  r: 4
}, {
  s: 6.7,
  r: -3
}, {
  s: 7.7,
  r: 2
}];
export function ContourLines({
  className = ''
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 1200 760" preserveAspectRatio="xMidYMid slice" fill="none" aria-hidden="true" focusable="false" className={className} data-id="element-31" data-mp="u3crwtkbdvtl">
      {RINGS.map(({
      s,
      r
    }) => <path key={s} d={RING} stroke="var(--border)" strokeWidth={1} vectorEffect="non-scaling-stroke" transform={`translate(${SUMMIT.x} ${SUMMIT.y}) rotate(${r}) scale(${s}) translate(-205 -150)`} data-id="element-32" data-mp="wrh1dt5iolkx" />)}
    </svg>;
}